(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elisura-multizona"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__emzCarousel) return;
    window.__emzCarousel = true;

    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      if (root.dataset.emzReady === 'true') return;
      var track = root.querySelector('[data-emz-track]');
      if (!track) return;
      root.dataset.emzReady = 'true';

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-emz-slide]'));
      var prev = root.querySelector('[data-emz-prev]');
      var next = root.querySelector('[data-emz-next]');
      var curve = root.querySelector('[data-emz-curve]');
      var dot = root.querySelector('[data-emz-dot]');
      var count = root.querySelector('[data-emz-count]');
      var depth = root.classList.contains('emz--depth');
      var total = slides.length;
      var ticking = false;
      var current = 0;

      function startPadding() {
        return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      }

      function slideLeft(slide) {
        return track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      }

      function indexFromScroll() {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 0 && track.scrollLeft >= max - 4) return total - 1;
        var anchor = track.scrollLeft + startPadding();
        var best = 0;
        var bestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slideLeft(slide) - anchor);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        return best;
      }

      function goTo(index) {
        index = Math.max(0, Math.min(total - 1, index));
        var left = slideLeft(slides[index]) - startPadding();
        track.scrollTo({ left: left, behavior: reduceQuery.matches ? 'auto' : 'smooth' });
      }

      function render() {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 1;
        var share = 1 / total;
        var visual = share + ratio * (1 - share);

        if (curve) {
          curve.style.strokeDashoffset = String(100 - visual * 100);
          if (dot && curve.getTotalLength) {
            var point = curve.getPointAtLength(curve.getTotalLength() * visual);
            dot.setAttribute('cx', point.x.toFixed(2));
            dot.setAttribute('cy', point.y.toFixed(2));
          }
        }

        current = indexFromScroll();
        if (count) count.textContent = (current + 1) + ' / ' + total;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = max <= 0 || track.scrollLeft >= max - 4;

        if (depth && !reduceQuery.matches) {
          var box = track.getBoundingClientRect();
          var center = box.left + box.width / 2;
          slides.forEach(function (slide) {
            var img = slide.querySelector('.emz__img');
            if (!img) return;
            var rect = slide.getBoundingClientRect();
            var offset = (rect.left + rect.width / 2 - center) / box.width;
            offset = Math.max(-1, Math.min(1, offset));
            img.style.transform = 'translate3d(' + (offset * -6).toFixed(2) + '%, 0, 0) scale(1.12)';
          });
        }
      }

      function requestRender() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(render);
      }

      track.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      track.addEventListener('keydown', function (event) {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
        if (event.key === 'Home') { event.preventDefault(); goTo(0); }
        if (event.key === 'End') { event.preventDefault(); goTo(total - 1); }
      });

      root._emzGoTo = function (slide) {
        var i = slides.indexOf(slide);
        if (i > -1) goTo(i);
      };

      root.classList.add('emz--ready');
      render();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-emz]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest && event.target.closest('[data-emz-slide]');
      if (!slide) return;
      var root = slide.closest('[data-emz]');
      if (root && root._emzGoTo) root._emzGoTo(slide);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tonoa-home"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
/* Lienzos originales (px). Los recursos deben conservar estos lienzos. */
var T={W:1024,H:1536,D:{x:512,y:1376},C:{x:512,y:760},
  poly:[[249,94],[775,94],[770,165],[668,1250],[600,1280],[585,1362],[532,1380],[512,1416],[490,1380],[440,1362],[425,1280],[356,1250],[256,165]],
  hero:[[249,94],[775,94],[770,165],[668,1250],[660,1482],[364,1482],[356,1250],[256,165]]};
var RIB={W:724,H:2172,step:24,B:{x:172,y:112},end:2100,
  L:[-1,-1,-1,131,123,123,132,161,193,211,223,233,243,253,265,278,292,309,326,344,360,375,386,397,405,410,414,416,416,414,410,405,398,391,381,371,360,347,335,322,310,299,291,285,282,281,281,283,287,293,302,309,318,330,344,360,378,390,399,406,411,415,417,418,418,417,415,411,406,399,389,378,363,346,325,298,257,202,159,124,98,80,80,89,116,169,-1,-1,-1,-1,-1],
  R:[-1,-1,-1,204,221,228,232,239,248,262,280,302,328,354,379,402,423,440,456,469,480,488,496,502,506,510,512,513,513,513,511,509,505,501,494,486,476,464,452,442,433,425,419,414,412,411,413,417,423,432,441,452,462,473,484,494,503,512,519,525,530,533,536,537,538,538,538,537,535,532,528,522,515,505,495,494,505,537,588,628,653,662,662,656,626,565,-1,-1,-1,-1,-1]};

var clamp=function(v,a,b){return v<a?a:v>b?b:v};
var sm=function(t){t=clamp(t,0,1);return t*t*(3-2*t)};
var map=function(v,a,b){return sm((v-a)/(b-a))};
var lerp=function(a,b,t){return a+(b-a)*t};
var rot=function(x,y,a){var c=Math.cos(a),s=Math.sin(a);return{x:x*c-y*s,y:x*s+y*c}};
var reduced=function(){return window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches};
function mixHex(a,b,t){var p=function(h,i){return parseInt(h.substr(1+i*2,2),16)};var o=[];for(var i=0;i<3;i++)o.push(Math.round(lerp(p(a,i),p(b,i),t)));return'rgb('+o.join(',')+')'}

/* perfil horizontal de la cinta: se mide sobre la imagen si el navegador lo permite */
function measureRibbon(src,cb){
  if(!src){cb(null);return}
  var im=new Image();im.crossOrigin='anonymous';
  im.onload=function(){try{
    var f=4,w=Math.round(im.naturalWidth/f),h=Math.round(im.naturalHeight/f),cv=document.createElement('canvas');cv.width=w;cv.height=h;
    var cx=cv.getContext('2d');cx.drawImage(im,0,0,w,h);var d=cx.getImageData(0,0,w,h).data,k=RIB.W/im.naturalWidth*f,band=Math.max(1,Math.round(RIB.step/(k))),L=[],R=[];
    for(var y0=0;y0<h;y0+=band){var mn=1e9,mx=-1;for(var y=y0;y<Math.min(h,y0+band);y++){for(var x=0;x<w;x++){if(d[(y*w+x)*4+3]>=60){if(x<mn)mn=x;if(x>mx)mx=x}}}
      L.push(mx<0?-1:Math.round(mn*k));R.push(mx<0?-1:Math.round(mx*k))}
    cb({L:L,R:R,step:band*k});
  }catch(e){cb(null)}};
  im.onerror=function(){cb(null)};im.src=src;
}
function applyProfile(p){
  if(!p||p.L.length<20)return;
  var i0=-1,i1=-1;for(var i=0;i<p.L.length;i++){if(p.L[i]>=0){if(i0<0)i0=i;i1=i}}
  if(i0<0)return;
  RIB.L=p.L;RIB.R=p.R;RIB.step=p.step;
  var xs=0,n=0;for(var j=i0;j<Math.min(i0+3,p.L.length);j++){if(p.L[j]>=0){xs+=(p.L[j]+p.R[j])/2;n++}}
  RIB.B={x:n?xs/n:172,y:(i0+1.4)*p.step};RIB.end=(i1+0.6)*p.step;
}

function Scene(root){
  var S=this;S.root=root;
  var q=function(s){return root.querySelector(s)};
  S.stage=q('.tn-stage');S.track=q('.tn-track');S.bg=q('.tn-bg');S.art=q('.tn-art');S.tube=q('.tn-tube');S.cap=q('.tn-l-cap');
  S.body=q('.tn-l-body');S.neck=q('.tn-l-neck');S.ribbon=q('.tn-ribbon');S.ribImg=q('.tn-ribbon img');S.shadow=q('.tn-shadow');
  S.hero=q('.tn-hero');S.top=q('.tn-top');S.msgs=[].slice.call(root.querySelectorAll('.tn-msg'));
  var ds=root.dataset;
  S.cfg={tilt:+ds.tilt||38,seam:+ds.seam||1268,capDy:ds.capDy!==undefined&&ds.capDy!==''?+ds.capDy:30,k:(+ds.ribbon||90)/100,along:ds.along!==undefined&&ds.along!==''?+ds.along:-4,len:(+ds.length||100)/100};
  S.u=0;S.cur=0;S.target=0;S.raf=0;S.last='';
  var imgs=[S.body,S.neck,S.cap,S.ribImg].filter(Boolean);
  var ok=imgs.length===4&&imgs.every(function(i){return i.getAttribute('src')});
  if(!ok){root.classList.add('is-plain');return}
  var pending=imgs.length+1,done=function(){if(--pending===0)S.start()};
  imgs.forEach(function(i){if(i.complete&&i.naturalWidth)done();else{i.addEventListener('load',done,{once:true});i.addEventListener('error',function(){root.classList.add('is-plain')},{once:true})}});
  measureRibbon(S.ribImg.currentSrc||S.ribImg.src,function(p){applyProfile(p);done()});
}
Scene.prototype.start=function(){
  var S=this;if(S.root.classList.contains('is-plain'))return;
  /* un contenedor del tema con overflow:hidden anula el efecto fijo: se cambia por clip (mismo recorte) o se usa la versión estática */
  var el=S.root.parentElement,clip=window.CSS&&CSS.supports&&CSS.supports('overflow','clip');
  while(el&&el!==document.body&&el!==document.documentElement){var cs=getComputedStyle(el),ox=cs.overflowX,oy=cs.overflowY;
    if(ox==='hidden'||oy==='hidden'){if(clip&&ox!=='scroll'&&oy!=='scroll'){el.style.overflowX=ox==='hidden'?'clip':'visible';el.style.overflowY=oy==='hidden'?'clip':'visible'}else S.noSticky=true}
    else if(ox==='auto'||ox==='scroll'||oy==='auto'||oy==='scroll')S.noSticky=true;
    el=el.parentElement}
  S.tube.style.setProperty('--tn-cut',(T.H-S.cfg.seam-4)+'px');
  S.tube.style.setProperty('--tn-na',(S.cfg.seam-8)+'px');S.tube.style.setProperty('--tn-nb',(S.cfg.seam+4)+'px');
  S.autoOffset();
  S.onScroll=function(){S.scroll()};S.onResize=function(){clearTimeout(S.rt);S.rt=setTimeout(function(){S.autoOffset();S.layout()},120)};
  window.addEventListener('scroll',S.onScroll,{passive:true});window.addEventListener('resize',S.onResize);
  S.layout();
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){S.last='';S.layout()});
};
/* encabezado fijo del tema: se mide solo, salvo que el ajuste manual tenga un valor */
Scene.prototype.autoOffset=function(){
  var S=this,root=S.root.parentElement;while(root&&!(root.classList&&root.classList.contains('tonoa')))root=root.parentElement;if(!root)return;
  var man=parseFloat(root.getAttribute('data-offset'))||0;if(man>0)return;
  var h=0,seen=[],cands=document.querySelectorAll('.shopify-section-group-header-group,.shopify-section-header-sticky,#shopify-section-header,#shopify-section-announcement-bar,.section-header,header,sticky-header,.header-wrapper');
  [].forEach.call(cands,function(el){if(root.contains(el))return;var e=el;while(e&&e!==document.body){var cs=getComputedStyle(e);if(cs.position==='sticky'||cs.position==='fixed'){if(seen.indexOf(e)<0)seen.push(e);break}e=e.parentElement}});
  seen.forEach(function(e){var hh=e.offsetHeight;if(hh>0&&hh<220)h=Math.max(h,hh)});
  root.style.setProperty('--tn-offset',Math.round(h)+'px');
};
Scene.prototype.destroy=function(){window.removeEventListener('scroll',this.onScroll);window.removeEventListener('resize',this.onResize);cancelAnimationFrame(this.raf)};
Scene.prototype.chooseMode=function(){
  var w=window.innerWidth,h=window.innerHeight;
  if(reduced()||this.noSticky)return'static';
  if(h<500||(w<900&&w>h*1.2))return'static';
  return'anim';
};
Scene.prototype.layout=function(){
  var S=this,mode=S.chooseMode();
  var key=mode+'|'+window.innerWidth+'|'+(mode==='anim'?S.stage.clientHeight:0);
  if(key===S.last)return;S.last=key;
  S.root.classList.toggle('is-anim',mode==='anim');S.root.classList.toggle('is-static',mode==='static');S.mode=mode;
  S.msgs.forEach(function(m){m.style.cssText='';m.classList.remove('tn-msg--end')});
  S.hero.style.cssText='';
  if(mode==='static'){S.track.style.height='';S.layoutStatic();return}
  var W=S.stage.clientWidth,H=S.stage.clientHeight,mob=W<900;
  var G=S.G={W:W,H:H,mob:mob};
  var a=-S.cfg.tilt*Math.PI/180;G.a=a;G.ax=rot(0,1,a);
  /* portada */
  var topInset=S.top?S.top.offsetTop+S.top.offsetHeight+4:14;
  if(mob){
    var heroH=S.hero.offsetHeight;
    var avail=H-topInset-heroH-22-12;
    G.s0=clamp(avail/1398,0.1,0.34);
    var y94=topInset+4;
    G.C0={x:W/2,y:y94+(T.C.y-94)*G.s0};
    S.hero.style.top=(y94+(1482-94)*G.s0+12)+'px';
    G.base={x:W/2,y:y94+(1482-94)*G.s0};
  }else{
    G.s0=Math.min(0.66*H/1388,W*0.3/527);
    G.C0={x:W*0.7,y:H/2+(T.C.y-788)*G.s0+topInset*0.25};
    G.base={x:G.C0.x,y:G.C0.y+(1482-T.C.y)*G.s0};
  }
  /* composición final */
  if(!S.solve()){S.last='';S.root.classList.remove('is-anim');S.root.classList.add('is-static');S.mode='static';S.track.style.height='';S.layoutStatic();return}
  var f=G.fin;
  G.C1=(function(){var v=rot((T.C.x-T.D.x)*f.s,(T.C.y-T.D.y)*f.s,a);return{x:f.N.x+v.x,y:f.N.y+v.y}})();
  S.ribbon.style.transform='translate('+f.rib.x+'px,'+f.rib.y+'px) scale('+f.rib.r+')';
  S.shadow.style.cssText='width:'+(300*G.s0)+'px;height:'+(46*G.s0)+'px;transform:translate('+(G.base.x-150*G.s0)+'px,'+(G.base.y-20*G.s0)+'px)';
  /* línea de tiempo (en alturas de pantalla) */
  var L=S.cfg.len,qB=(RIB.B.y+50)/RIB.H,qs=[];
  f.msgs.forEach(function(m,i){var ay=m.y+Math.min(m.h*0.35,42);var qq=clamp((ay-f.rib.y)/(f.rib.r*RIB.H),qB+0.03,0.95);if(i&&qq<qs[i-1]+0.02)qq=Math.min(0.97,qs[i-1]+0.02);qs.push(qq)});
  var u=0.62,K=[[u,qB]],mu=[];
  for(var i=0;i<qs.length;i++){u+=0.30;K.push([u,qs[i]]);mu.push(u);if(i<qs.length-1){u+=0.34*L;K.push([u,Math.min(qs[i]+0.025,0.99)])}}
  /* tras el último mensaje la crema termina de caer y forma el charco mientras se lee; luego pausa con todo visible */
  var u3=u;u+=0.42*L;K.push([u,1]);u+=0.36*L;
  G.K=K;G.mu=mu;G.uEnd=u;G.uRose=[u3-0.05,u3+0.42*L];
  S.track.style.height=(H*(1+u))+'px';
  S.msgs.forEach(function(m,i){var p=f.msgs[i];m.style.width=p.w+'px';m.style.transform='translate('+p.x+'px,'+p.y+'px)';m.dataset.x=p.x;m.dataset.y=p.y;if(p.end)m.classList.add('tn-msg--end')});
  S.scroll(true);
};
/* obstáculos: intervalo horizontal ocupado por el pomo y la cinta dentro de una franja vertical */
Scene.prototype.band=function(y0,y1){
  var f=this.G.try_,pts=f.pts,tl=1e9,tr=-1e9,n=pts.length;
  for(var i=0;i<n;i++){var p=pts[i],q=pts[(i+1)%n];
    if(p.y>=y0&&p.y<=y1){tl=Math.min(tl,p.x);tr=Math.max(tr,p.x)}
    [y0,y1].forEach(function(yy){if((p.y-yy)*(q.y-yy)<0){var x=p.x+(q.x-p.x)*(yy-p.y)/(q.y-p.y);tl=Math.min(tl,x);tr=Math.max(tr,x)}})}
  var rb=f.rib,c0=Math.floor((y0-rb.y)/rb.r/RIB.step)-1,c1=Math.floor((y1-rb.y)/rb.r/RIB.step)+1,sl=1e9,sr=-1e9;
  for(var j=Math.max(0,c0);j<=Math.min(RIB.L.length-1,c1);j++){if(RIB.L[j]>=0){sl=Math.min(sl,rb.x+RIB.L[j]*rb.r);sr=Math.max(sr,rb.x+RIB.R[j]*rb.r)}}
  return{tl:tl,tr:tr,sl:sl,sr:sr};
};
Scene.prototype.fit=function(el,side,yMin,yMax,anchor){
  var S=this,G=S.G,mob=G.mob,pad=mob?20:32,gapX=mob?14:36,gapY=mob?10:16,minW=mob?168:250,maxW=mob?330:(side==='R'?400:380);
  var h=el._h||140;
  for(var y=yMin;y+60<=yMax;y+=6){
    var w=0,x=0,good=false;
    for(var it=0;it<5;it++){
      var b=S.band(y-gapY,y+h+gapY),xl,xr;
      if(side==='L'){xr=Math.min(b.tl,b.sl)-gapX;xl=pad;w=Math.min(maxW,xr-xl);x=(mob||anchor==='left')?xl:xr-w}
      else{xl=Math.max(b.tr,b.sr)+gapX;xr=G.W-pad;w=Math.min(maxW,xr-xl);x=xl}
      if(w<minW){good=false;break}
      el.style.width=w+'px';var nh=el.offsetHeight;good=true;
      if(Math.abs(nh-h)<1){h=nh;break}h=nh;
    }
    if(good){var b2=S.band(y-gapY,y+h+gapY),lim=side==='L'?Math.min(b2.tl,b2.sl)-gapX:Math.max(b2.tr,b2.sr)+gapX;
      var fine=side==='L'?(x+w<=lim+0.5):(x>=lim-0.5);
      if(fine&&y+h<=yMax){el._h=h;return{x:x,y:y,w:w,h:h,end:(!mob&&side==='L')}}}
  }
  return null;
};
Scene.prototype.solve=function(){
  var S=this,G=S.G,W=G.W,H=G.H,mob=G.mob,a=G.a,k=S.cfg.k,al=S.cfg.along;
  var rel=T.poly.map(function(p){return rot(p[0]-T.D.x,p[1]-T.D.y,a)});
  var minX=Math.min.apply(null,rel.map(function(p){return p.x})),minY=Math.min.apply(null,rel.map(function(p){return p.y}));
  var mt=mob?18:28,mb=mob?8:18,textBottom=H-(mob?16:30);
  var rTop=(RIB.B.y-40)*k,rBot=(RIB.end-RIB.B.y)*k,rR=(662-RIB.B.x)*k;
  var s=Math.min(mob?0.3:0.4,(H-mt-mb)/(-minY+al*G.ax.y+rBot)),sMin=mob?0.12:0.16;
  for(;s>=sMin;s*=0.955){
    var r=k*s,N={},A={};
    N.y=mt-minY*s;A.y=N.y+G.ax.y*al*s;
    if(mob){A.x=W-12-rR*r;N.x=A.x-G.ax.x*al*s;if(N.x+minX*s<6)continue}
    else{A.x=W*0.53-(400-RIB.B.x)*r;N.x=A.x-G.ax.x*al*s;if(N.x+minX*s<24)N.x=24-minX*s,A.x=N.x+G.ax.x*al*s}
    var pts=T.poly.map(function(p){var v=rot((p[0]-T.D.x)*s,(p[1]-T.D.y)*s,a);return{x:N.x+v.x,y:N.y+v.y}});
    G.try_={s:s,N:N,pts:pts,rib:{x:A.x-RIB.B.x*r,y:A.y-RIB.B.y*r,r:r}};
    var res=S.placeAll(textBottom,0);
    if(res){
      var bottom=Math.max.apply(null,res.map(function(m){return m.y+m.h})),slack=textBottom-bottom;
      if(slack>12){var e=Math.min(slack/(res.length+(mob?0.6:1)),mob?46:70);var r2=S.placeAll(textBottom,e);if(r2)res=r2}
      G.try_.msgs=res;G.fin=G.try_;return true;
    }
  }
  return false;
};
Scene.prototype.placeAll=function(yMax,e){
  var S=this,G=S.G,f=G.try_,m=S.msgs,out=[],gap=(G.mob?22:30)+e;
  if(G.mob){
    var y=Math.max(18,f.N.y-140)+e*0.6;
    for(var i=0;i<m.length;i++){var p=S.fit(m[i],'L',y,yMax);if(!p)return null;out.push(p);y=p.y+p.h+gap}
    return out;
  }
  var p1=S.fit(m[0],'R',f.N.y-10+e*0.5,yMax);if(!p1)return null;
  var p2=S.fit(m[1],'L',p1.y+p1.h*0.5+e*0.5,yMax);if(!p2)return null;
  var p3=S.fit(m[2],'R',Math.max(p1.y+p1.h+gap,p2.y+p2.h*0.5+e*0.5),yMax);if(!p3)return null;
  /* alinear los mensajes de la derecha en una misma columna */
  if(p3.x>p1.x+2){var nx=p3.x,nw=Math.min(p1.w,G.W-32-nx);m[0].style.width=nw+'px';var nh=m[0].offsetHeight;
    if(nw>=250&&p1.y+nh+gap<=p3.y){p1={x:nx,y:p1.y,w:nw,h:nh,end:false}}else{m[0].style.width=p1.w+'px'}}
  else if(p1.x>p3.x+2){var nx3=p1.x,nw3=Math.min(p3.w,G.W-32-nx3);m[2].style.width=nw3+'px';var nh3=m[2].offsetHeight;
    if(nw3>=250&&p3.y+nh3<=yMax){p3={x:nx3,y:p3.y,w:nw3,h:nh3,end:false}}else{m[2].style.width=p3.w+'px'}}
  return[p1,p2,p3];
};
Scene.prototype.scroll=function(now){
  var S=this;if(S.mode!=='anim')return;
  var r=S.track.getBoundingClientRect(),off=parseFloat(getComputedStyle(S.root).getPropertyValue('--tn-offset'))||0;
  S.target=clamp((off-r.top)/S.G.H,0,S.G.uEnd);
  if(now===true){S.cur=S.target;S.render(S.cur);return}
  if(!S.raf)S.raf=requestAnimationFrame(function tick(){
    S.cur+=(S.target-S.cur)*0.16;
    if(Math.abs(S.target-S.cur)<0.0008){S.cur=S.target;S.render(S.cur);S.raf=0;return}
    S.render(S.cur);S.raf=requestAnimationFrame(tick);
  });
};
Scene.prototype.qAt=function(u){var K=this.G.K;if(u<=K[0][0])return 0;for(var i=1;i<K.length;i++){if(u<=K[i][0]){var t=(u-K[i-1][0])/(K[i][0]-K[i-1][0]);return lerp(K[i-1][1],K[i][1],sm(t))}}return 1};
Scene.prototype.pose=function(t){
  var G=this.G,f=G.fin;return{s:lerp(G.s0,f.s,t),a:G.a*t,C:{x:lerp(G.C0.x,G.C1.x,t),y:lerp(G.C0.y,G.C1.y,t)}};
};
Scene.prototype.render=function(u){
  var S=this,G=S.G;
  var t1=sm((u-0.04)/0.58),P=S.pose(t1);
  S.tube.style.transform='translate('+P.C.x+'px,'+P.C.y+'px) rotate('+P.a+'rad) scale('+P.s+') translate('+(-T.C.x)+'px,'+(-T.C.y)+'px)';
  var tc=sm((u-0.2)/0.36);
  S.cap.style.transform='translateY('+(S.cfg.capDy+tc*330)+'px) rotate('+(-14*tc)+'deg) scale('+(1-0.14*tc)+')';
  S.cap.style.opacity=1-map(u,0.4,0.58);
  S.shadow.style.opacity=1-map(u,0.02,0.22);
  var q=S.qAt(u);S.ribbon.style.setProperty('--tn-q',q.toFixed(4));S.ribbon.style.opacity=q>0?1:0;
  var th=map(u,0,0.28);S.hero.style.opacity=1-th;S.hero.style.visibility=th>0.99?'hidden':'visible';
  S.hero.style.transform=(G.mob?'':'translateY(-50%) ')+'translateY('+(-22*th)+'px)';
  S.msgs.forEach(function(m,i){var o=map(u,G.mu[i]-0.16,G.mu[i]+0.02);m.style.opacity=o;
    m.style.transform='translate('+m.dataset.x+'px,'+(+m.dataset.y+12*(1-o))+'px)';m.classList.toggle('is-on',o>0.6)});
  S.bg.style.background=mixHex('#FAF7F2','#E6C5CE',map(u,G.uRose[0],G.uRose[1]));
};
Scene.prototype.layoutStatic=function(){
  var S=this;S.tube.style.transform='';
  var box=S.art,Wf=box.clientWidth,mob=window.innerWidth<900;
  var Hf=mob?Math.min(560,Math.round(Wf*1.35)):Math.min(720,Math.round(window.innerHeight*0.86));
  S.root.style.setProperty('--tn-fig',Hf+'px');
  var a=-S.cfg.tilt*Math.PI/180,k=S.cfg.k,ax=rot(0,1,a),al=S.cfg.along;
  var rel=T.poly.map(function(p){return rot(p[0]-T.D.x,p[1]-T.D.y,a)});
  var xs=rel.map(function(p){return p.x}),ys=rel.map(function(p){return p.y});
  var bx0=Math.min(Math.min.apply(null,xs),(80-RIB.B.x)*k),bx1=Math.max(Math.max.apply(null,xs),(662-RIB.B.x)*k);
  var by0=Math.min.apply(null,ys),by1=(RIB.end-RIB.B.y)*k+ax.y*al;
  var s=Math.min((Wf-24)/(bx1-bx0),(Hf-24)/(by1-by0),0.4),r=k*s;
  var N={x:(Wf-(bx1-bx0)*s)/2-bx0*s,y:(Hf-(by1-by0)*s)/2-by0*s},A={x:N.x+ax.x*al*s,y:N.y+ax.y*al*s};
  var C=rot((T.C.x-T.D.x)*s,(T.C.y-T.D.y)*s,a);
  S.tube.style.transform='translate('+(N.x+C.x)+'px,'+(N.y+C.y)+'px) rotate('+a+'rad) scale('+s+') translate('+(-T.C.x)+'px,'+(-T.C.y)+'px)';
  S.cap.style.opacity=0;S.shadow.style.opacity=0;
  S.ribbon.style.transform='translate('+(A.x-RIB.B.x*r)+'px,'+(A.y-RIB.B.y*r)+'px) scale('+r+')';
  S.ribbon.style.setProperty('--tn-q','1.05');S.ribbon.style.opacity=1;
};

/* cierre: frase que se ilumina palabra por palabra */
function Words(el){
  var txt=el.textContent.replace(/\s+/g,' ').trim();if(!txt)return;
  el.setAttribute('aria-label',txt);
  el.innerHTML=txt.split(' ').map(function(w){return'<span class="tn-w" aria-hidden="true">'+w.replace(/[&<>]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;'}[c]})+'</span>'}).join(' ');
  var ws=[].slice.call(el.querySelectorAll('.tn-w')),tk=false;
  /* subrayado dibujado: envuelve las palabras elegidas en el editor */
  var hl=(el.getAttribute('data-tn-highlight')||'').trim(),hlEl=null;
  if(hl){var norm=function(s){return s.toLowerCase().replace(/[^\p{L}\p{N}]+/gu,'')};var want=hl.split(/\s+/).map(norm).filter(Boolean),wn=ws.map(function(w){return norm(w.textContent)});
    for(var s0=0;s0+want.length<=wn.length&&!hlEl;s0++){var okm=true;for(var k=0;k<want.length;k++){if(wn[s0+k]!==want[k]){okm=false;break}}
      if(okm){var wrap=document.createElement('span');wrap.className='tn-hl';ws[s0].parentNode.insertBefore(wrap,ws[s0]);
        for(var k2=0;k2<want.length;k2++){if(k2)wrap.appendChild(document.createTextNode(' '));wrap.appendChild(ws[s0+k2])}
        wrap.insertAdjacentHTML('beforeend','<svg viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden="true"><path d="M3 7C30 3 60 10 95 6S160 3 197 7" pathLength="1" vector-effect="non-scaling-stroke"/></svg>');
        hlEl={el:wrap,last:s0+want.length-1}}}}
  var paint=function(){tk=false;var r=el.getBoundingClientRect(),vh=window.innerHeight;
    var p=reduced()?1:clamp((vh*0.88-r.top)/(vh*0.5),0,1),n=Math.round(p*ws.length);ws.forEach(function(w,i){w.classList.toggle('is-on',i<n)});
    if(hlEl)hlEl.el.classList.toggle('is-on',n>hlEl.last)};
  window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(paint)}},{passive:true});paint();
}
function productLinks(root){
  var url=(root.getAttribute('data-product-url')||'').trim();if(!url)return;
  [].forEach.call(root.querySelectorAll('[data-tn-product]'),function(a){a.setAttribute('href',url)});
}
function init(scope){
  [].forEach.call((scope||document).querySelectorAll('.tonoa'),function(root){
    if(root._tn)return;root._tn=true;
    var sc=root.querySelector('[data-tn-scene]');if(sc)root._scene=new Scene(sc);
    productLinks(root);[].forEach.call(root.querySelectorAll('[data-tn-words]'),Words);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
document.addEventListener('shopify:section:load',function(e){init(e.target)});
document.addEventListener('shopify:section:unload',function(e){var r=e.target.querySelector('.tonoa');if(r&&r._scene&&r._scene.destroy)r._scene.destroy()});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tonoa-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var clamp=function(v,a,b){return v<a?a:v>b?b:v};
var reduced=function(){return window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches};

/* encabezado fijo del tema: se mide solo, salvo que el ajuste manual tenga un valor */
function autoOffset(root){
  var man=parseFloat(root.getAttribute('data-offset'))||0;if(man>0)return man;
  var h=0,seen=[],cands=document.querySelectorAll('.shopify-section-group-header-group,.shopify-section-header-sticky,#shopify-section-header,#shopify-section-announcement-bar,.section-header,header,sticky-header,.header-wrapper');
  [].forEach.call(cands,function(el){if(root.contains(el))return;var e=el;while(e&&e!==document.body){var cs=getComputedStyle(e);if(cs.position==='sticky'||cs.position==='fixed'){if(seen.indexOf(e)<0)seen.push(e);break}e=e.parentElement}});
  seen.forEach(function(e){var hh=e.offsetHeight;if(hh>0&&hh<220)h=Math.max(h,hh)});
  root.style.setProperty('--tn-offset',Math.round(h)+'px');return h;
}

/* cierre: frase que se ilumina palabra por palabra, con subrayado dibujado sobre las palabras elegidas */
function Words(el){
  var txt=el.textContent.replace(/\s+/g,' ').trim();if(!txt)return;
  el.setAttribute('aria-label',txt);
  el.innerHTML=txt.split(' ').map(function(w){return'<span class="tp-w" aria-hidden="true">'+w.replace(/[&<>]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;'}[c]})+'</span>'}).join(' ');
  var ws=[].slice.call(el.querySelectorAll('.tp-w')),tk=false;
  var hl=(el.getAttribute('data-tp-highlight')||'').trim(),hlEl=null;
  if(hl){var norm=function(s){return s.toLowerCase().replace(/[^\p{L}\p{N}]+/gu,'')};var want=hl.split(/\s+/).map(norm).filter(Boolean),wn=ws.map(function(w){return norm(w.textContent)});
    for(var s0=0;s0+want.length<=wn.length&&!hlEl;s0++){var okm=true;for(var k=0;k<want.length;k++){if(wn[s0+k]!==want[k]){okm=false;break}}
      if(okm){var wrap=document.createElement('span');wrap.className='tp-hl';ws[s0].parentNode.insertBefore(wrap,ws[s0]);
        for(var k2=0;k2<want.length;k2++){if(k2)wrap.appendChild(document.createTextNode(' '));wrap.appendChild(ws[s0+k2])}
        wrap.insertAdjacentHTML('beforeend','<svg viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden="true"><path d="M3 7C30 3 60 10 95 6S160 3 197 7" pathLength="1" vector-effect="non-scaling-stroke"/></svg>');
        hlEl={el:wrap,last:s0+want.length-1}}}}
  var paint=function(){tk=false;var r=el.getBoundingClientRect(),vh=window.innerHeight;
    var p=reduced()?1:clamp((vh*0.88-r.top)/(vh*0.5),0,1),n=Math.round(p*ws.length);ws.forEach(function(w,i){w.classList.toggle('is-on',i<n)});
    if(hlEl)hlEl.el.classList.toggle('is-on',n>hlEl.last)};
  window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(paint)}},{passive:true});paint();
}

/* botón del cierre: vuelve al formulario de compra del tema (packs y botón), o al inicio si no lo encuentra */
function toPacks(root){
  [].forEach.call(root.querySelectorAll('[data-tp-topacks]'),function(a){a.addEventListener('click',function(e){
    e.preventDefault();
    /* 1) marcador propio · 2) bloque de packs de Shrine (radios de cantidad / quantity breaks) · 3) formulario de compra · 4) inicio */
    var t=document.querySelector('[data-tp-packs]');
    if(!t){var r=document.querySelector('input[type="radio"][name*="uantity"],input[type="radio"][name*="pack"],input[type="radio"][name*="bundle"],[class*="quantity-break"],[class*="qty-break"],[class*="quantity_break"],[class*="bundle"]');
      if(r){t=r.closest('[class*="quantity-break"],[class*="qty-break"],[class*="bundle"],.shopify-block,[id^="shopify-block"]')||r.parentElement}}
    if(!t)t=document.querySelector('form[action*="/cart/add"]');
    var go=function(){var off=autoOffset(root),top=t?t.getBoundingClientRect().top+window.pageYOffset-off-12:0;
      window.scrollTo({top:Math.max(0,top),behavior:reduced()?'auto':'smooth'})};
    go();
    /* si el encabezado del tema reaparece al subir, se corrige la posición final */
    setTimeout(function(){if(!t)return;var off=autoOffset(root),rt=t.getBoundingClientRect().top;if(rt<off+4)window.scrollBy({top:rt-off-12,behavior:'auto'})},reduced()?50:700);
  })});
}

/* antes/después: el control deslizante mueve el corte de la foto "después" */
function initBA(root){
  [].forEach.call(root.querySelectorAll('[data-tp-ba]'),function(box){
    var r=box.querySelector('.tp-ba-range');if(!r)return;
    var set=function(){box.style.setProperty('--tp-x',r.value+'%')};
    r.addEventListener('input',set);set();
  });
}
/* tipos de mancha: pestañas accesibles (clic, flechas del teclado) */
function initTabs(root){
  [].forEach.call(root.querySelectorAll('[data-tp-tabs]'),function(ui){
    var tabs=[].slice.call(ui.querySelectorAll('[role="tab"]'));
    var show=function(t,focus){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;
      var p=document.getElementById(x.getAttribute('aria-controls'));if(p){if(on)p.removeAttribute('hidden');else p.setAttribute('hidden','')}});
      if(focus)t.focus();
      var bar=t.parentElement;if(bar&&bar.scrollWidth>bar.clientWidth){bar.scrollTo({left:t.offsetLeft-bar.offsetLeft-16,behavior:reduced()?'auto':'smooth'})}};
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){show(t)});
      t.addEventListener('keydown',function(e){var k=e.key,n=null;if(k==='ArrowRight')n=tabs[(i+1)%tabs.length];else if(k==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length];else if(k==='Home')n=tabs[0];else if(k==='End')n=tabs[tabs.length-1];if(n){e.preventDefault();show(n,true)}});
    });
  });
}
function init(scope){
  [].forEach.call((scope||document).querySelectorAll('.tnp'),function(root){
    if(root._tp)return;root._tp=true;
    autoOffset(root);window.addEventListener('resize',function(){clearTimeout(root._rt);root._rt=setTimeout(function(){autoOffset(root)},120)});
    [].forEach.call(root.querySelectorAll('[data-tp-words]'),Words);toPacks(root);initBA(root);initTabs(root);
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluti-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var reduced = function(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* "Cómo se usa": baja suave (o salta, si se pidió menos movimiento) */
  function Jump(root){
    [].forEach.call(root.querySelectorAll('[data-vh-jump]'), function(a){
      a.addEventListener('click', function(e){
        var t = document.querySelector(a.getAttribute('href')); if(!t) return;
        e.preventDefault(); t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function Reveal(root){
    var els = [].slice.call(root.querySelectorAll('.vh-rv'));
    if(reduced() || !('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.classList.add('is-js');
    els.forEach(function(e){ io.observe(e); });
  }

  function Revs(root){
    [].forEach.call(root.querySelectorAll('[data-vh-revs]'), function(w){
      var t = 0;
      var p = function(){ w.classList.add('is-paused'); clearTimeout(t); t = setTimeout(function(){ w.classList.remove('is-paused'); }, 4000); };
      w.addEventListener('touchstart', p, { passive: true });
      w.addEventListener('pointerdown', p);
    });
  }

  function init(where){
    var scopes = (where && where.querySelectorAll ? where : document).querySelectorAll('.vlh');
    [].forEach.call(scopes, function(sc){
      if(sc.__vh) return; sc.__vh = true;
      try { Reveal(sc); } catch(e){ sc.classList.remove('is-js'); }
      Revs(sc); Jump(sc);
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluti-producto"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var reduced = function(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* selector de compra de Shrine (packs / formulario de producto) fuera de esta sección */
  function packTarget(root){
    var custom = root.getAttribute('data-buy-sel');
    var sels = (custom ? [custom] : []).concat(['.quantity-break', '.quantity_break', '.quantity-breaks', 'form[action*="/cart/add"]', '.product-form', '.product__form', '#AddToCartForm']);
    for(var i = 0; i < sels.length; i++){
      var els; try { els = document.querySelectorAll(sels[i]); } catch(e){ continue; }
      for(var j = 0; j < els.length; j++){
        var el = els[j];
        if(root.contains(el) || el.offsetParent === null) continue;
        return el;
      }
    }
    return null;
  }

  function Pack(root){
    [].forEach.call(root.querySelectorAll('[data-vp-pack]'), function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        var t = packTarget(root), b = reduced() ? 'auto' : 'smooth';
        if(t){ t.scrollIntoView({ behavior: b, block: 'center' }); }
        else { window.scrollTo({ top: 0, behavior: b }); }
      });
    });
  }

  function Reveal(root){
    var els = [].slice.call(root.querySelectorAll('.vp-rv'));
    if(reduced() || !('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.classList.add('is-js');
    els.forEach(function(e){ io.observe(e); });
  }

  function Revs(root){
    [].forEach.call(root.querySelectorAll('[data-vp-revs]'), function(w){
      var t = 0;
      var p = function(){ w.classList.add('is-paused'); clearTimeout(t); t = setTimeout(function(){ w.classList.remove('is-paused'); }, 4000); };
      w.addEventListener('touchstart', p, { passive: true });
      w.addEventListener('pointerdown', p);
    });
  }

  function Timeline(root){
    var wks = [].slice.call(root.querySelectorAll('.vp-wk'));
    if(!wks.length) return null;
    var raf = 0;
    var run = function(){
      raf = 0; var vh = window.innerHeight;
      wks.forEach(function(w){ w.classList.toggle('is-on', w.getBoundingClientRect().top < vh * .72); });
      wks.forEach(function(w, i){ var n = wks[i+1]; w.classList.toggle('is-done', !!(n && n.classList.contains('is-on'))); });
    };
    var q = function(){ if(!raf) raf = requestAnimationFrame(run); };
    window.addEventListener('scroll', q, { passive: true });
    window.addEventListener('resize', q);
    run();
    return function(){ window.removeEventListener('scroll', q); window.removeEventListener('resize', q); cancelAnimationFrame(raf); };
  }

  function Reel(root){
    var offs = [];
    [].forEach.call(root.querySelectorAll('[data-vp-reel]'), function(reel){
      var clips = [].slice.call(reel.querySelectorAll('[data-vp-clip]'));
      var nav = reel.nextElementSibling && reel.nextElementSibling.classList.contains('vp-reel-nav') ? reel.nextElementSibling : null;
      var dots = nav ? [].slice.call(nav.querySelectorAll('.vp-dots button')) : [];
      var prev = nav && nav.querySelector('.vp-prev'), next = nav && nav.querySelector('.vp-next');
      var idx = 0;
      var go = function(i){ i = Math.max(0, Math.min(clips.length - 1, i)); reel.scrollTo({ left: clips[i].offsetLeft - reel.firstElementChild.offsetLeft, behavior: reduced() ? 'auto' : 'smooth' }); };
      var sync = function(){
        var l = reel.scrollLeft, best = 0, d = 1e9;
        clips.forEach(function(c, i){ var x = Math.abs(c.offsetLeft - reel.firstElementChild.offsetLeft - l); if(x < d){ d = x; best = i; } });
        if(reel.scrollLeft + reel.clientWidth >= reel.scrollWidth - 4) best = clips.length - 1;
        idx = best;
        dots.forEach(function(b, i){ b.classList.toggle('is-on', i === idx); });
        if(prev) prev.disabled = reel.scrollLeft < 4;
        if(next) next.disabled = reel.scrollLeft + reel.clientWidth >= reel.scrollWidth - 4;
      };
      var raf = 0, onScroll = function(){ if(!raf) raf = requestAnimationFrame(function(){ raf = 0; sync(); }); };
      reel.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function(b, i){ b.addEventListener('click', function(){ go(i); }); });
      if(prev) prev.addEventListener('click', function(){ go(idx - 1); });
      if(next) next.addEventListener('click', function(){ go(idx + 1); });

      /* videos: solo se reproducen los que se ven (ahorra datos y batería) */
      var vids = clips.map(function(c){ var v = c.querySelector('video'); if(!v) return null;
        v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.removeAttribute('autoplay'); v.pause();
        var bar = c.querySelector('.vp-clip-bar i');
        if(bar) v.addEventListener('timeupdate', function(){ if(v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')'; });
        return v; });
      var io = null;
      if('IntersectionObserver' in window){
        io = new IntersectionObserver(function(en){
          en.forEach(function(x){ var c = x.target, v = c.querySelector('video'); if(!v) return;
            if(x.isIntersecting && x.intersectionRatio > .6 && !reduced()){ var p = v.play(); if(p && p.catch) p.catch(function(){}); c.classList.add('is-play'); }
            else { v.pause(); c.classList.remove('is-play'); }
          });
        }, { threshold: [0, .6, 1] });
        clips.forEach(function(c){ if(c.querySelector('video')) io.observe(c); });
      }
      sync();
      offs.push(function(){ reel.removeEventListener('scroll', onScroll); if(io) io.disconnect(); });
    });
    return offs.length ? function(){ offs.forEach(function(f){ f(); }); } : null;
  }

  var live = [];
  function init(where){
    var scopes = (where && where.querySelectorAll ? where : document).querySelectorAll('.vlp');
    [].forEach.call(scopes, function(sc){
      if(sc.__vp) return; sc.__vp = true;
      try { Reveal(sc); } catch(e){ sc.classList.remove('is-js'); }
      Revs(sc); Pack(sc);
      var offs = [Timeline(sc), Reel(sc)].filter(Boolean);
      if(offs.length) live.push({ root: sc, off: function(){ offs.forEach(function(f){ f(); }); } });
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:section:unload', function(e){
    live = live.filter(function(l){ if(e.target.contains(l.root)){ l.off(); return false; } return true; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
